








































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { State } from 'vuex-class'
import logger from '@plat-components/utils2/_esm5/logger'
import { linkJump } from '@bilibili/utils-leona'
import { WorkItem } from '@/model/business'
import { highlightList } from '@/utils/config'
import Badge from '@/components/badge.vue'
@Component({
  components: {
    Badge,
  },
})
export default class Stage extends Vue {
  @State('currPoint') currPoint

  @Prop(Object)
  currItem!: WorkItem
  @Prop(Object)
  nextItem!: WorkItem
  @Prop(Boolean)
  changeWork!: true
  @Prop(Boolean)
  isHighlight!: false
  @Prop(Object)
  highlightInfo!: any

  get heightBg() {
    return this.highlightInfo
      ? { backgroundImage: `url(${this.highlightInfo['workInfoSrc']})` }
      : {}
  }

  @Watch('currPoint')
  watchCurrPointChange(newVal) {
    let currInx = highlightList.findIndex((item) => item.station === newVal)
    if (currInx !== -1) {
      // 本地存储title
      const localStore = localStorage.getItem('getTitle')
      const titleInfo = (localStore && JSON.parse(localStore)) || []
      let hasStore = titleInfo.some((item) => item === newVal)
      if (!hasStore) {
        localStorage.setItem(
          'getTitle',
          JSON.stringify(titleInfo.concat(this.highlightInfo.station))
        )
      }
    }
  }

  navToWatch(item: any) {
    const { ssid } = item || {}
    linkJump({
      link: `https://m.bilibili.com/bangumi/play/ss${ssid}`,
    })
  }

  // 获取称号
  handleGetTitle() {
    // 获取称号
    logger('ensureforecast_click', {
      periods: this.currPoint,
    })
    let link = this.highlightInfo.linkSrc

    link &&
      linkJump({
        link,
      })
  }
}
